<template>
  <div id="_2024_1">
    <div id="The-fourth-Asian-young-geographers-workshop" class="cos-modal">
      <h3><strong>The Fourth Asian Young Geographers Workshop Held in Yuxi</strong></h3>
      <small class="home-date">December 6, 2024<br></small>
      <hr>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The Fourth Asian Young Geographers Workshop was held in Yuxi,
        Yunnan Province, from November 29 to December 2, 2024. The workshop was jointly organized
        by the Young Geographers Working Group of the Asian Geographical Association (AGA-YGWG),
        the Working Committee for Young Geographers of the Geographical Society of China
        (GSC-WCYG), and the Young Scientist Innovation Network of the International Society for
        Digital Earth (ISDE-YSIN). It was hosted by Yuxi Normal University and co-organized by the
        IGU Young and Early Career Geographers Commission (IGU-YECG). A total of 378 experts and
        scholars from 58 institutions across 11 countries gathered in Yuxi for two days of
        exchange and discussion under the theme “Asian Geography under Global Change.”
      </p>

      <figure class="featured-photo">
        <img
          src="../../../assets/static/img/Events/2024_1/01-opening-ceremony.jpg"
          alt="Opening ceremony of the Fourth Asian Young Geographers Workshop"
        >
        <figcaption>Opening ceremony of the workshop</figcaption>
      </figure>

      <h4>Opening Ceremony</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The opening ceremony was held on the morning of November 30 in the
        lecture hall of the Yuxi Normal University Library. It was chaired by Prof. Min Chen of
        Nanjing Normal University, Chair of AGA-YGWG. Prof. Hongyun Duan, President of Yuxi Normal
        University; Prof. Lai Vinh Cam, Vice President of the Asian Geographical Association;
        Prof. Michael Meadows, former President of the International Geographical Union; and
        Prof. Fahu Chen, President of the Geographical Society of China and an academician of the
        Chinese Academy of Sciences, delivered welcome addresses.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/02-min-chen.jpg"
            alt="Professor Min Chen chairing the opening ceremony"
          >
          <figcaption>Prof. Min Chen chairs the opening ceremony</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/03-hongyun-duan.jpg"
            alt="Professor Hongyun Duan delivering a welcome address"
          >
          <figcaption>Prof. Hongyun Duan delivers a welcome address</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/04-vinh-cam-lai.jpg"
            alt="Professor Lai Vinh Cam addressing the workshop"
          >
          <figcaption>Prof. Lai Vinh Cam addresses the workshop</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/05-michael-meadows.jpg"
            alt="Professor Michael Meadows addressing the workshop"
          >
          <figcaption>Prof. Michael Meadows addresses the workshop</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/06-fahu-chen.jpg"
            alt="Professor Fahu Chen addressing the workshop"
          >
          <figcaption>Prof. Fahu Chen addresses the workshop</figcaption>
        </figure>
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;During the opening ceremony, Associate Prof. Prabuddh Kumar
        Mishra, Joint Secretary of the National Association of Geographers, India, introduced the
        Sixth Asian Conference on Geography, which was scheduled to be held in New Delhi, India,
        in November 2025.
      </p>

      <figure class="featured-photo">
        <img
          src="../../../assets/static/img/Events/2024_1/07-prabuddh-kumar-mishra.jpg"
          alt="Associate Professor Prabuddh Kumar Mishra introducing the Sixth Asian Conference on Geography"
        >
        <figcaption>
          Associate Prof. Prabuddh Kumar Mishra introduces the Sixth Asian Conference on Geography
        </figcaption>
      </figure>

      <h4>Invited Presentations</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The invited presentation sessions were chaired in turn by Dr.
        Gaurav Sikka of Lalit Narayan Mithila University, India, Chair of IGU-YECG, and Associate
        Prof. Li He of Xi’an Jiaotong University, Secretary General of AGA-YGWG. Prof. Fahu Chen,
        President of the Geographical Society of China and an academician of the Chinese Academy
        of Sciences; Prof. Maria Paradiso of the University of Naples Federico II, Italy, Vice
        President of the International Geographical Union; and Paco Acedo, a member of the Spanish
        Geographical Society, documentary producer, and explorer, delivered academic and public
        outreach presentations entitled “Spatial Heterogeneity and the ‘Giant Sandwich’ Pattern
        of Decadal Variability in the Asian Summer Rainfall Zone and Their Impacts,” “Are You a
        Geographer? Find Your Place in Geography,” and “Write Your Own Story: Curiosity Is the
        Only Reason to Explore,” respectively. Associate Prof. Prabuddh Kumar Mishra of the
        University of Delhi, India, and Prof. Guanpeng Dong of Henan University delivered
        academic presentations entitled “Multiple Perspectives on Natural Resource Conservation
        in the Himalayan Region” and “Spatially Explicit Climate Econometric Models,”
        respectively.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/08-fahu-chen-keynote.jpg"
            alt="Professor Fahu Chen delivering an invited presentation"
          >
          <figcaption>Prof. Fahu Chen delivers an invited presentation</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/09-maria-paradiso-keynote.jpg"
            alt="Professor Maria Paradiso delivering an invited presentation"
          >
          <figcaption>Prof. Maria Paradiso delivers an invited presentation</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/10-paco-acedo-keynote.png"
            alt="Paco Acedo delivering a public outreach presentation"
          >
          <figcaption>Paco Acedo delivers a public outreach presentation</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/11-prabuddh-kumar-mishra-keynote.jpg"
            alt="Associate Professor Prabuddh Kumar Mishra delivering an invited presentation"
          >
          <figcaption>Associate Prof. Prabuddh Kumar Mishra delivers an invited presentation</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/12-guanpeng-dong-keynote.jpg"
            alt="Professor Guanpeng Dong delivering an invited presentation"
          >
          <figcaption>Prof. Guanpeng Dong delivers an invited presentation</figcaption>
        </figure>
      </div>

      <h4>Parallel Sessions and Roundtable</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Parallel discussions were held on the afternoon of November 30
        and throughout December 1. The program comprised ten thematic parallel sessions and one
        journal editors’ roundtable, with 77 presentations and discussion activities in total.
        Under the theme “Asian Geography under Global Change,” participants exchanged research
        on territorial spatial optimization and functional improvement; sustainable Asian urban
        landscapes; spatial accessibility; land-use and land-cover change, its drivers,
        consequences, and policy responses; the development and application of geographic
        intelligence foundation models; urban–rural land-use change and ecological well-being;
        land management and spatiotemporal big-data modeling; innovative perspectives on
        compound and cascading disaster-risk assessment and response; energy geography and
        sustainable development; urban and rural governance and sustainability in a new era;
        geographic simulation and optimization; and the writing and publication of geography
        papers. The sessions examined the effects of global change on Asia’s physical geography,
        human geography, geographical science, and environmental science, while showcasing new
        achievements in Asian geographical research from multiple perspectives.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/13-parallel-session.jpg"
            alt="A thematic parallel session"
          >
          <figcaption>A thematic parallel session</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/14-editor-roundtable.jpg"
            alt="Journal editors roundtable"
          >
          <figcaption>Journal editors’ roundtable</figcaption>
        </figure>
      </div>

      <h4>Closing Ceremony</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The closing ceremony was held on the evening of December 1 and
        chaired by Associate Prof. Li He. Dr. Gaurav Sikka delivered a presentation entitled
        “Synergies for Sustainable Youth Action between the IGU Young and Early Career
        Geographers Commission and the Asian Young Geographers Workshop.” Prof. Min Chen gave the
        concluding remarks, introduced the workshop’s initial outcomes, and thanked the organizing
        committee, volunteers, and all participants for making the workshop’s first in-person
        edition a success.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;An awards ceremony followed. After a comprehensive assessment by
        the organizing committee, seven papers received Excellent Paper Awards. Prof. Michael
        Meadows, Prof. Maria Paradiso, and Prof. Lai Vinh Cam presented the awards. Award
        representatives Hongqing Li of Technische Universität Berlin, Deshang Kong of Huazhong
        University of Science and Technology, Ao Qing of the Institute of Geographic Sciences
        and Natural Resources Research, Chinese Academy of Sciences, and Zhuo Sun of Nanjing
        Normal University delivered acceptance speeches. The host then declared the workshop
        closed, thanked everyone for their participation and contributions, and invited attendees
        to continue following AGA-YGWG’s future activities.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/15-closing-ceremony.jpg"
            alt="Closing ceremony of the workshop"
          >
          <figcaption>Closing ceremony of the workshop</figcaption>
        </figure>
        <figure>
          <img
            src="../../../assets/static/img/Events/2024_1/16-awards-ceremony.jpg"
            alt="Excellent Paper Awards ceremony"
          >
          <figcaption>Excellent Paper Awards ceremony</figcaption>
        </figure>
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The Asian Young Geographers Workshop pioneered a new forum for
        exchange among young geographers in Asia. Its inaugural meeting in December 2021 created
        a new international platform, promoted exchange and cooperation among geographical
        institutions and young geographers across Asia, and advanced the development of the Asian
        Geographical Association. After three online editions, this was the first workshop held
        in person since its inception. It further strengthened the workshop’s identity and
        expanded the platform’s influence. Participants gained knowledge and inspiration,
        stimulated innovative thinking, and contributed their expertise to the development of
        geography in Asia and to addressing the many geographical challenges facing the region.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Established in 2020, the Young Geographers Working Group of the
        Asian Geographical Association (AGA-YGWG) aims to provide young geographers with a
        platform for collaboration and academic exchange. Focusing on major issues such as the
        environment, health, and sustainable development, it brings together young geographers
        from physical geography, human geography, geographic information science, and related
        fields to build a closely connected Asian academic community.
      </p>

      <figure class="featured-photo group-photo">
        <img
          src="../../../assets/static/img/Events/2024_1/17-group-photo.jpg"
          alt="Group photo from the Fourth Asian Young Geographers Workshop"
        >
        <figcaption>Group photo from the Fourth Asian Young Geographers Workshop</figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2024_1'
}
</script>

<style lang="less" scoped>
#_2024_1 {
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 2.2rem auto 0;
  position: relative;
  word-spacing: 0.3rem;
  min-height: 3200px;
  text-align: justify;
}

h3,
h4 {
  color: #117450;
  font-weight: 1000;
}

h3 {
  font-size: 1.3rem;
}

h4 {
  margin: 2rem 0 1rem;
  font-size: 1.2rem;
}

.home-date {
  font-weight: bold;
  color: grey;
}

figure {
  margin: 0;
}

.featured-photo {
  width: 100%;
  margin: 2% 0;
  text-align: center;
}

.featured-photo img {
  max-width: 80%;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  margin: 2% 0;
}

.photo-grid figure {
  text-align: center;
}

figure img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

figcaption {
  margin-top: 0.4rem;
  color: grey;
  font-size: 0.9rem;
  line-height: 1.4rem;
  text-align: center;
}

@media (max-width: 768px) {
  #_2024_1 {
    width: 88%;
    min-height: 0;
  }

  .featured-photo img {
    max-width: 100%;
  }

  .photo-grid {
    grid-template-columns: 1fr;
  }
}
</style>
